/**
 * Duration helpers.
 * REACT_APP_MEETING_MAX_DURATION_MINUTES is ONLY the default length for instant
 * meetings / schedule-form defaults. Live end timer follows scheduledEndTime.
 */
function minutesFromEnv(name, fallback) {
  const raw = process.env[name];
  const n = raw != null && String(raw).trim() !== '' ? Number(raw) : NaN;
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/** Default length for instant meetings / schedule form default end. */
export const MAX_MEETING_DURATION_MINUTES = minutesFromEnv(
  'REACT_APP_MEETING_MAX_DURATION_MINUTES',
  45
);
export const MEETING_END_WARNING_MINUTES = minutesFromEnv(
  'REACT_APP_MEETING_END_WARNING_MINUTES',
  5
);

export const MAX_MEETING_DURATION_MS = MAX_MEETING_DURATION_MINUTES * 60 * 1000;
export const MEETING_END_WARNING_MS = MEETING_END_WARNING_MINUTES * 60 * 1000;

export function formatDateTimeLocal(date) {
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/** @deprecated Prefer using the scheduled/calendar end time as-is. */
export function capMeetingEndTime(startTime, endTime) {
  const end = new Date(endTime);
  return { endTime: end, capped: false, maxEnd: end };
}
